import { useMemo } from 'react'
import { TransmitterMesh } from '@scene'
import { useHiddenElements } from '@editor/hooks'
import { useModelStore, useTransmissionStore } from '@editorStores'
import useEmitModelClickListenerV2 from '../hooks/useEmitModelClickListenerV2'
import { useModelMeshStore } from '../state/store'

interface Props {
  disableClick?: boolean
}

const VerticalTransmittersMesh = ({ disableClick }: Props) => {
  const verticalTransmissionGraph = useTransmissionStore(state => state.verticalTransmissionGraph)
  const domains = useModelStore(state => state.domains)

  const hiddenGuids = useModelMeshStore(state => state.hiddenGuids)

  const hiddenElements = useHiddenElements()

  const selectedElements = useModelMeshStore(state => state.selectedGuids)

  const visibleTransmitterElementGuids = useModelMeshStore(
    state => state.visibleVerticalTransmitterElementGuids,
  )

  const executeListener = useEmitModelClickListenerV2()

  const allHiddenGuids = useMemo(() => {
    return new Set([...hiddenElements, ...Array.from(hiddenGuids.values()).flat()])
  }, [hiddenElements, hiddenGuids])

  const allVisibleTransmitterElementGuids = useMemo(() => {
    return Array.from(visibleTransmitterElementGuids.values()).flat()
  }, [visibleTransmitterElementGuids])

  const allSelectedGuids = useMemo(() => {
    return Array.from(selectedElements.values()).flat()
  }, [selectedElements])

  return (
    <group visible={allVisibleTransmitterElementGuids.length > 0}>
      <TransmitterMesh
        data={verticalTransmissionGraph}
        pointConnectorKind="vertical"
        domains={domains}
        transmitterGuid={allSelectedGuids.length ? (allSelectedGuids[0] as string) : undefined}
        onClick={({ guid, element_guid }, event) =>
          executeListener('global-vertical-transmitter-mesh', event, {
            type: 'vertical_transmitter',
            elementGuid: element_guid,
            transmitterGuid: guid,
          })
        }
        elementGuids={allVisibleTransmitterElementGuids}
        hiddenElements={allHiddenGuids}
        disableClick={allVisibleTransmitterElementGuids.length === 0 || disableClick}
      />
    </group>
  )
}

export { VerticalTransmittersMesh }
